import React, { ChangeEvent } from 'react';

import { Box, Typography } from '@material-ui/core';
import type { GridSortModel } from '@mui/x-data-grid';

import { AppSearchInput } from '@vyce/core/src/components/inputs';
import { FormDoc, FormRecipientsDialogType } from '@vyce/core/src/types';
import { GRID_PAGE_SIZE } from '@vyce/core/src/constants';
import { FormsDataGrid } from './FormsDataGrid';

interface Props {
  rows: FormDoc[];
  dragType: string;
  withActions?: boolean;
  onEditForm?: (form: FormDoc) => void;
  onPreviewForm?: (form: FormDoc) => void;
  onDuplicateForm?: (form: FormDoc) => Promise<void> | void;
  onSettingsForm?: (form: FormDoc) => void;
  onSendForm?: (form: FormDoc) => void;
  onArchiveForm?: (form: FormDoc) => void;
  onViewAnswers?: (form: FormDoc) => void;
  onDeleteForm?: (form: FormDoc) => void;
  onChangeFolder?: (form: FormDoc) => void;
  onViewOutstanding?: (form: FormDoc) => void;
  onViewParticipants?: (form: FormDoc, type: FormRecipientsDialogType) => void;
  onResendAll?: (form: FormDoc) => void;
  onOpenAIAnalytics?: (form: FormDoc) => void;
  loading: boolean;
  total: number;
  sortModel: GridSortModel;
  onSortModelChange: (model: GridSortModel) => void;
  onPageChange: (page: number) => void;
  setOffset: (offset: number) => void;
  onSearchChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const UnassignedFormsSection: React.FC<Props> = ({
  rows,
  dragType,
  withActions = false,
  onEditForm,
  onPreviewForm,
  onDuplicateForm,
  onSettingsForm,
  onSendForm,
  onArchiveForm,
  onViewAnswers,
  onDeleteForm,
  onChangeFolder,
  onViewOutstanding,
  onViewParticipants,
  onResendAll,
  onOpenAIAnalytics,
  loading,
  total,
  sortModel,
  onSortModelChange,
  onPageChange,
  setOffset,
  onSearchChange,
}) => {
  return (
    <>
      <Box display="flex" alignItems="center" flexWrap="wrap" gridGap={12} marginBottom={2}>
        <Typography variant="h6">Unassigned forms</Typography>
        <AppSearchInput
          placeholder="Search..."
          onChange={onSearchChange}
          isSmall
          smallRounding
          isBorder
          expanded={true}
        />
      </Box>
      <FormsDataGrid
        rows={rows}
        enableDragAndDrop
        dragType={dragType}
        withActions={withActions}
        onEditForm={onEditForm}
        onPreviewForm={onPreviewForm}
        onDuplicateForm={onDuplicateForm}
        onSettingsForm={onSettingsForm}
        onSendForm={onSendForm}
        onArchiveForm={onArchiveForm}
        onViewAnswers={onViewAnswers}
        onDeleteForm={onDeleteForm}
        onChangeFolder={onChangeFolder}
        onViewOutstanding={onViewOutstanding}
        onViewParticipants={onViewParticipants}
        onResendAll={onResendAll}
        onOpenAIAnalytics={onOpenAIAnalytics}
        height="calc(100vh - 320px)"
        loading={loading}
        total={total}
        sortModel={sortModel}
        onSortModelChange={onSortModelChange}
        pageSize={GRID_PAGE_SIZE}
        rowsPerPageOptions={[GRID_PAGE_SIZE]}
        onPageChange={onPageChange}
        setOffset={setOffset}
      />
    </>
  );
};
